import { render, staticRenderFns } from "./super_sidebar_toggle.vue?vue&type=template&id=18891558"
import script from "./super_sidebar_toggle.vue?vue&type=script&lang=js"
export * from "./super_sidebar_toggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports